import { render, staticRenderFns } from "./no_credits_empty_state.vue?vue&type=template&id=2f4510b0"
import script from "./no_credits_empty_state.vue?vue&type=script&lang=js"
export * from "./no_credits_empty_state.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports